module.exports = __webpack_public_path__ + "static/media/certificat-de-participation.6b11e667.pdf";